export default __webpack_public_path__ + "static/media/ed2mit2021tuto03_rsch-data-mngt-v02.5d70fee6.pdf";